import { render, staticRenderFns } from "./SelectUserForDepOrRole.vue?vue&type=template&id=f1855d1c&"
import script from "./SelectUserForDepOrRole.vue?vue&type=script&lang=js&"
export * from "./SelectUserForDepOrRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports